import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Store"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5003 8.01005L21.0003 3.51005C20.893 3.19102 20.5864 2.98251 20.2503 3.00005H3.75029C3.41418 2.98251 3.10754 3.19102 3.00029 3.51005L1.50029 8.01005C1.48949 8.08969 1.48949 8.17042 1.50029 8.25005V12.7501C1.50029 13.1643 1.83608 13.5001 2.25029 13.5001H3.00029V21.0001H4.50029V13.5001H9.00029V21.0001H21.0003V13.5001H21.7503C22.1645 13.5001 22.5003 13.1643 22.5003 12.7501V8.25005C22.5111 8.17042 22.5111 8.08969 22.5003 8.01005ZM19.5003 19.5H10.5003V13.5H19.5003V19.5ZM21.0003 12H18.0003V9.00003H16.5003V12H12.7503V9.00003H11.2503V12H7.50031V9.00003H6.00031V12H3.00031V8.37003L4.29031 4.50003H19.7103L21.0003 8.37003V12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Store.vue"]]);
